import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import MultipleSelectField from "../Reusable/MultipleSelectField";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import ImageField from "../Reusable/ImageField";
import LocalCombobox from "../Reusable/LocalCombobox";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import SwitchButton from "../Reusable/FormSwitchButton";
import { useEffect, useState } from "react";
import Modal from "../Reusable/Modal";
import CreateUserBranch from "./CreateUserBranch";
import { getApiData } from "../../helpers/AxiosInstance";

const BranchForm = ({
  errors,
  register,
  setValue,
  getValues,
  clearErrors,
  watch,
  branchData,
  control,
  isCreate = false,
}: any) => {
  const [openBranchFormPopup, setOpenBranchFormPopup] = useState(false);
  const TypeData = [
    {
      name: "flat",
      id: "flat",
    },
    {
      name: "percentage",
      id: "percentage",
    },
  ];
  const branch = watch("name");

  useEffect(() => {
    const fetchBranchData = async () => {
      if (isCreate) {
        const branchRes = await getApiData(`${APIS.USER_BRANCH}${branch}/`);
        console.log(branchRes, "branchRes in branch form");
        if (branchRes) {
          setValue("vat_pan", branchRes?.data?.vat_pan);
          setValue("code", branchRes?.data?.code);
          setValue("primary_email", branchRes?.data?.primary_email);
          setValue("primary_contact", branchRes?.data?.primary_contact);
          setValue("secondary_contact", branchRes?.data?.primary_contact);
        }
      }
    };
    fetchBranchData();
  }, [branch, branchData, setValue, isCreate]);

  console.log(branch, "branch in branch form");
  return (
    <>
      <div className={tw`flex w-full gap-x-4 px-4`}>
        <div className={tw`w-full`}>
          {isCreate ? (
            <div className={tw`w-full flex gap-x-2 items-end`}>
              <div className={tw`flex-1`}>
                <ComboboxInput
                  label={"Branch"}
                  placeholder={"Select Branch"}
                  url={APIS.USER_BRANCH}
                  queryKey={"branches"}
                  register={register("name")}
                  errors={errors?.name}
                  name={"name"}
                  setValue={setValue}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
              </div>

              <button
                className={tw`border px-4 py-1 text-xl bg-[#EEF5F4] focus:outline-none`}
                type="button"
                onClick={() => setOpenBranchFormPopup(!openBranchFormPopup)}
              >
                +
              </button>
            </div>
          ) : (
            <TextField
              label={"Branch Name"}
              register={register("name")}
              errors={errors?.code}
            />
          )}

          <TextField
            label={"Code"}
            register={register("code")}
            errors={errors?.code}
          />
          <TextField
            label={"Company Name"}
            register={register("company_name")}
            errors={errors?.company_name}
          />
          <TextField
            label={"VAT/PAN"}
            register={register("vat_pan")}
            errors={errors?.vat_pan}
          />
        </div>
        <div className={tw`w-full`}>
          <TextField
            label={"Email"}
            register={register("primary_email")}
            errors={errors?.primary_email}
          />
          <PhoneNumberField
            control={control}
            label={"Primary Phone"}
            name={"primary_contact"}
            errors={errors?.primary_contact}
          />
          <PhoneNumberField
            control={control}
            label={"Secondary Contact"}
            name={"secondary_contact"}
            errors={errors?.secondary_contact}
          />
          <TextField
            label={"Full Address"}
            register={register("landmark")}
            errors={errors?.landmark}
          />
        </div>
      </div>
      <div className={tw`w-full mt-2 font-semibold text-left mx-4`}>
        <p>Other Info</p>
      </div>
      <div className={tw`grid md:grid-cols-2 gap-x-4 mx-4`}>
        <ComboboxInput
          label={"Branch Manager"}
          placeholder={"Branch Manager"}
          url={APIS.USER}
          queryKey={"user"}
          register={register("manager")}
          errors={errors?.manager}
          name={"manager"}
          props={{
            is_active: true,
            is_staff: true,
          }}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"Warehouse"}
          placeholder={"Warehouse"}
          url={APIS.WAREHOUSE}
          props={{ level: 0, is_active: true }}
          queryKey={"warehouse"}
          register={register("warehouse")}
          errors={errors?.warehouse}
          name={"warehouse"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <MultipleSelectField
          label={"Covered City"}
          queryKey={"covered-city"}
          register={register("covered_city")}
          watch={watch}
          setValue={setValue}
          url={`${APIS.LOCATION}flat-location/`}
          errors={errors.covered_city}
          value={
            branchData?.covered_city
              ? branchData?.covered_city?.map((item: any, index: number) => ({
                  label: item?.name,
                  value: item?.id,
                }))
              : []
          }
          props={{
            level: 3,
            is_active: true,
          }}
        />
        <MultipleSelectField
          label={"Service Branch"}
          queryKey={"service-branch"}
          register={register("service_branch")}
          watch={watch}
          setValue={setValue}
          props={{
            is_active: true,
          }}
          url={APIS.BRANCH}
          value={
            branchData?.service_branch
              ? branchData?.service_branch?.map((item: any, index: number) => ({
                  label: item?.name,
                  value: item?.id,
                }))
              : []
          }
        />
        <ComboboxInput
          url={APIS.DELIVERY_CHARGE_TEMPLATE}
          props={{
            is_active: true,
            is_branch: true,
          }}
          queryKey={"delivery-charge-template"}
          register={register("default_rate_template")}
          errors={errors?.default_rate_template}
          name={"default_rate_template"}
          label={"Branch Charge Template"}
          setValue={setValue}
          placeholder={"Search Delivery Charge Template"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <LocalCombobox
          label={"Charge Type"}
          placeholder={"Search charge type"}
          props={{}}
          register={register("charge_type")}
          errors={errors?.charge_type}
          name={"charge_type"}
          setValue={setValue}
          clearErrors={clearErrors}
          data={TypeData}
          value={getValues("charge_type")}
        />
        <TextField
          label={"Charge Rate"}
          register={register("charge")}
          errors={errors?.charge}
        />
        <TextField
          label={"Transit Charge"}
          register={register("transit_charge")}
          errors={errors?.transit_charge}
        />
        <div className={tw` w-full`}>
          <div className={tw`flex  w-full justify-end gap-x-2   right-0 `}>
            <label htmlFor="">Franchise</label>
            <SwitchButton
              register={register("is_franchise")}
              name={"is_franchise"}
              setValue={setValue}
              value={getValues("is_franchise")}
            />
          </div>
          {watch("is_franchise") ? (
            <div className={tw`w-full`}>
              <ImageField control={control} name={"logo"} label="Logo" />
            </div>
          ) : null}
        </div>
      </div>
      <Modal
        title={"Create Branch"}
        isOpen={openBranchFormPopup}
        setIsOpen={setOpenBranchFormPopup}
      >
        <CreateUserBranch setIsOpen={setOpenBranchFormPopup} />
      </Modal>
    </>
  );
};

export default BranchForm;
